import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/excessInventory'
import Component from 'components/Reports/ExcessInventoryReport'

export default createListViewContainer({ actions, selectors: selectors.excessInventoryReport })(Component)
